export const LAYOUT_SOLO = 'solo'
export const LAYOUT_PIP = 'pip'
export const LAYOUT_GRID = 'grid'
export const LAYOUT_CAROUSEL = 'carousel'
export const LAYOUT_SCREEN_SHARE = 'screenShare'

export const MAX_PER_PAGE = 6

export function getLayoutMode(totalParticipants, hasScreenShare) {
  if (hasScreenShare) return LAYOUT_SCREEN_SHARE
  if (totalParticipants <= 1) return LAYOUT_SOLO
  if (totalParticipants === 2) return LAYOUT_PIP
  if (totalParticipants <= 6) return LAYOUT_GRID
  return LAYOUT_CAROUSEL
}

export function getGridTemplate(count) {
  switch (count) {
  case 3:
    return { columns: 2, rows: 2 }
  case 4:
    return { columns: 2, rows: 2 }
  case 5:
    return { columns: 3, rows: 2 }
  case 6:
    return { columns: 3, rows: 2 }
  default:
    return { columns: 2, rows: 2 }
  }
}

export function paginateParticipants(allParticipants, activeSpeakerIdentity, perPage = MAX_PER_PAGE) {
  if (allParticipants.length <= perPage) {
    return [allParticipants]
  }

  const speakerIdx = activeSpeakerIdentity
    ? allParticipants.findIndex(p => p.identity === activeSpeakerIdentity)
    : -1

  const ordered = [...allParticipants]

  if (speakerIdx > 0) {
    const [speaker] = ordered.splice(speakerIdx, 1)
    ordered.unshift(speaker)
  }

  const pages = []
  for (let i = 0; i < ordered.length; i += perPage) {
    pages.push(ordered.slice(i, i + perPage))
  }

  return pages
}
